/* eslint-disable */
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { currentUser } from "services/users/authSlice";
import { useSelector } from "react-redux";
// chakra imports

export function SidebarLinks(props) {
  // Chakra color mode
  var user = useSelector(currentUser);
  let location = useLocation();

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const checkPermission = (permissions) => {
    var isShow = false;
    var roles = [];
    if (user.is_manager && user.school.type === 1) {
      roles.push("km");
    }
    if (user.is_manager && user.school.type === 0) {
      roles.push("sm");
    }
    if (user.is_manager) {
      roles.push("m");
    }
    if (user.is_teacher) {
      roles.push("t");
    }
    if (user.is_student) {
      roles.push("s");
    }
    if (user.is_food_technologist) {
      roles.push("f");
    }
    if (user.is_chef) {
      roles.push("ch");
    }
    for (let i = 0; i < permissions.length; i++) {
      if (permissions[i] === "-") {
        break;
      } else if (permissions[i] === "*") {
        isShow = true;
        break;
      } else {
        for (let l = 0; l < roles.length; l++) {
          if (permissions[i].toUpperCase() === roles[l].toUpperCase()) {
            isShow = true;
            break;
          }
        }
      }
    }

    return isShow;
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      var isShow = checkPermission(route.permissions);
      if ((route.layout === "/admin" || route.layout === "/auth") && isShow) {
        return (
          <Link key={index} to={route.layout + "/" + route.path}>
            <div
              key={index}
              className={`relative m-2 mb-3 flex hover:cursor-pointer ${
                activeRoute(route.path) === true
                  ? "rounded-lg bg-activeOrange py-2"
                  : " "
              }`}
            >
              <li
                className="my-[3px] flex cursor-pointer items-center px-8"
                key={index}
              >
                <span
                  className={`${
                    activeRoute(route.path) === true
                      ? "font-medium text-white dark:text-white"
                      : "font-medium text-iconGrey"
                  }`}
                >
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <p
                  className={`leading-1 ml-4 flex ${
                    activeRoute(route.path) === true
                      ? "font-medium text-white dark:text-white"
                      : "font-medium text-iconGrey"
                  }`}
                >
                  {route.name}
                </p>
              </li>
              {/* {activeRoute(route.path) ? (
                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-activeOrange dark:bg-brand-400" />
              ) : null} */}
            </div>
          </Link>
        );
      }
    });
  };
  // BRAND
  return createLinks(routes);
}

export default SidebarLinks;
